import { AssetRequestUserGroup } from '@atom/types/assetRequest';

import ADOTGroupMembersTooltip from './ADOTGroupMembersTooltip';

import classes from './adotView.module.css';

type ADOTAssignedGroupProps = {
  group: AssetRequestUserGroup;
};

const ADOTAssignedGroup = ({ group }: ADOTAssignedGroupProps) => (
  <ADOTGroupMembersTooltip groupId={group.id}>
    <span
      className={classes.groupLink}
      data-cy={`adotTransferAssignedGroup-${group.name}`}
    >
      {group.name}
    </span>
  </ADOTGroupMembersTooltip>
);

export default ADOTAssignedGroup;
